export default __webpack_public_path__ + "2a6c1b58b4e8ada0ce09f4842c5e278f.svg";